import {
  BrandType,
  UpdateProductMutationVariables,
  useProductQuery,
  useUpdateProductMutation,
} from "../../generated/graphql";
import { useToast } from "@chakra-ui/react";
import Loading from "../../components/loading/Loading";
import { Navigate, useNavigate } from "react-router-dom";
import Form from "./Form";

interface Props {
  id: string;
}

const Update: React.VFC<Props> = ({ id }) => {
  const [updateMutation] = useUpdateProductMutation();
  const navigation = useNavigate();
  const toast = useToast();

  const { loading, error, data } = useProductQuery({
    variables: {
      where: {
        id,
      },
    },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Loading />;
  }
  if (error) {
    return <Navigate to={"/product"} replace />;
  }

  const disconnectProductWithCollection = async () => {
    try {
      const result = await updateMutation({
        variables: {
          where: { id: id },
          data: {
            collection: { disconnect: true },
          },
        },
      });
      navigation(
        `/product/${
          result.data?.updateProduct.brand === BrandType.SINEMIS ? "sinemis" : "bold"
        }`
      );
      return toast({
        status: "success",
        title: "Başarılı",
        description: "Ürün güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation(
            `/product/${
              result.data?.updateProduct.brand === BrandType.SINEMIS ? "sinemis" : "bold"
            }`
          );
        },
      });
    } catch (error: any) {
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  const handleUpdate = async (data: UpdateProductMutationVariables) => {
    try {
      const result = await updateMutation({
        variables: {
          ...data,
        },
      });

      navigation(
        `/product/${
          result.data?.updateProduct.brand === BrandType.SINEMIS ? "sinemis" : "bold"
        }`
      );
      return toast({
        status: "success",
        title: "Başarılı",
        description: "Ürün güncellendi",
        duration: 1000,
        onCloseComplete: () => {
          return navigation(
            `/product/${
              result.data?.updateProduct.brand === BrandType.SINEMIS ? "sinemis" : "bold"
            }`
          );
        },
      });
    } catch (error: any) {
      console.log(error.message);
      return toast({
        status: "error",
        title: "Hata",
        description: error.message || "Bir hata oluştu",
        duration: 1000,
      });
    }
  };

  return (
    <Form
      actionType="UPDATE"
      data={data?.product}
      id={id}
      handleUpdate={handleUpdate}
      disconnectProductWithCollection={disconnectProductWithCollection}
    />
  );
};

export default Update;
